import * as React from "react"

function IconPetrolDiesel(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={60} height={60} viewBox="0 0 60 60" {...props}>
      <title>{"Petrol and diesel"}</title>
      <g fill="none" fillRule="evenodd" stroke="#E3E833" strokeWidth={2}>
        <path d="M20.074 20h19.978L47 25.976V41a3 3 0 01-3 3H20.046h0L16 40.007h-3V24.1h3l4.074-4.1zM24.171 15.094h14.167M52 26.953V42M8 25.023V39M8 29.055h5M8 35h5M47 38h5M47 31.055h5M33.945 19.5v-4M28 19.5v-4M22.728 27.143h15.61M22.728 32h15.61M22.728 37h15.61" />
      </g>
    </svg>
  )
}

export default IconPetrolDiesel
